export default __webpack_public_path__ + "static/media/1897.fd9d5cb3.png";